import { Box, CardContent, Typography } from '@mui/material'
import React, { useContext, useEffect } from 'react';
import { Update } from '../App';
import { useLocation, useNavigate } from 'react-router-dom';
// import { TransparentCanvas } from 'react-remove-green-background'

// import * as imaging from "@asposecloud/aspose-imaging-cloud";
// const imagingApi = new ImagingApi("c39858eb6e32419411a369de8f6d99af", "7d447da5-ed3e-4fae-b896-2760863a3d1d");
// 

const Dashboard = () => {
  const {setDisplayAppBar,displayAppBar } = useContext(Update);
  const location = useLocation();
  const navigate=useNavigate();
  useEffect(()=>
  {
    if(location.pathname==='/dashboard')
    {
      setDisplayAppBar("block");
    }
   
  },[location.pathname])
  
  return (
    <Box sx={{display:"flex",justifyContent:"center",mt:{xs:"20%",lg:"10%"}}}>
      <CardContent sx={{transform:"rotate(-10deg)",fontSize:{xs:"34px",md:"44px"},fontWeight:"bold",}}>
      Development Mode
      </CardContent>
    </Box>
  )
}

export default Dashboard
